import axios from 'axios';


const api = axios.create({

 // baseURL: 'https://e-student.kpru.ac.th/refund/api/'
 baseURL: 'https://admission.kpru.ac.th/refund/api/'
// baseURL: 'http://localhost:5000/api/'
});



const URL = axios.create({

  // baseURL: 'https://e-student.kpru.ac.th/refund/api/'
  baseURL: 'https://conference.kpru.ac.th/adminconference-sd'
 // baseURL: 'http://localhost:3000/adminconference-sd'
 });

const apilogin = axios.create({
//baseURL: 'https://e-student.kpru.ac.th/refund/api/',
baseURL: 'hhttps://admission.kpru.ac.th/refund/api/',
//baseURL: 'http://localhost:5000/api/',
  headers: {
    'Authorization': 'Bearer ' + window.localStorage.getItem('auth')
  }
});


export { api, apilogin, URL };
